import { render, staticRenderFns } from "./CoursesAndInstructorsMobile.vue?vue&type=template&id=1020117a&scoped=true"
import script from "./CoursesAndInstructorsMobile.vue?vue&type=script&lang=js"
export * from "./CoursesAndInstructorsMobile.vue?vue&type=script&lang=js"
import style0 from "./CoursesAndInstructorsMobile.vue?vue&type=style&index=0&id=1020117a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1020117a",
  null
  
)

export default component.exports